// removed by extract-text-webpack-plugin
module.exports = {"faq":"style__faq__1Q5TT","pro":"style__pro__1EXze"};


//////////////////
// WEBPACK FOOTER
// ./src/components/faq/style.scss
// module id = 1065
// module chunks = 0